import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UtilsService } from 'src/app/shared/utils.service';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { User } from 'src/app/auth/user.model';
import { AuthService } from 'src/app/auth/auth.service';
import { AddEditPositioningComponent } from './add-edit-positioning/add-edit-positioning.component';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { DataService } from 'src/app/shared/data.service';
import { ChallengeDetailsComponent } from './challenge-details/challenge-details.component';

@Component({
    selector: 'app-competitor-positioning',
    templateUrl: './competitor-positioning.component.html',
    styleUrls: ['./competitor-positioning.component.scss'],
    standalone: false
})
export class CompetitorPositioningComponent implements OnInit {
  productId: any;
  productName: any;
  competitorId: any;
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  showSearch: boolean;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  userID: number;
  positioningList = new Array<any>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    usedOnMobile: boolean | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    usedOnMobile: null
  };

  searchValue = "";
  selected = 'manufacturer';
  usedOnMobile = null;
  user: User;
  competitorName: any;
  positioningId = null;

  constructor(private router: Router, public utils: UtilsService, private route: ActivatedRoute,
              private authService: AuthService,
              public dialog: MatDialog, public dataService: DataService) {
    this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
    this.productName = router.routerState.snapshot.root.children[0].children[0].params.name;
    this.competitorId = router.routerState.snapshot.root.children[0].children[0].params.competitorId;
    this.competitorName = decodeURIComponent(router.routerState.snapshot.root.children[0].children[0].params.competitorName);
    this.showSearch = false;
    this.user = this.authService.getUserData();
    this.userID = this.user.id;
    this.route.params
    .subscribe(
      (params: Params) => {
        this.competitorId = params.competitorId;
      });
    this.route.queryParams.subscribe((params: Params) => {
      if (!this.isEmpty(params)) {
        this.positioningId = params.positioningId ? params.positioningId : null;
        this.pageNumber = params.pageNumber ? params.pageNumber : 1;
        this.pageSize = params.pageSize ? params.pageSize : 10;
        this.searchValue =  params.searchValue ? params.searchValue : "";
        this.usedOnMobile = params.usedOnMobile;
        this.selected = params.usedOnMobile === 'true'  ? 'usedOnMobile'  : 'manufacturer';
        if (params.usedOnMobile === undefined) {
          if (this.user.type === this.utils.userTypes.Distributor) {
            this.usedOnMobile = true;
          } else {
            this.usedOnMobile = null;
          }
          this.selected = 'usedOnMobile';
        }
        } else {
          if (this.user.type === this.utils.userTypes.Distributor) {
            this.selected = 'usedOnMobile';
            this.usedOnMobile = true;
          }
        }
      this.getPositioning();
      if (this.positioningId) {
        this.openChallengeDetails({id: this.positioningId});
      }
      });
    }

  ngOnInit(): void {
    this.utils.setTitle('Products');
    this.utils.screenTitle.emit({firstTitle: 'Products', firstRoute: '/products',
        secondTitle: this.productName, secondRoute: '/products/product/' + this.productId + '/' + this.productName + '/general',
        thirdTitle: 'Competitor Positioning (' + this.competitorName + ')'
      });
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }

    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  openChallengeDetails(challenge: any) {
    const dialogRef = this.dialog.open(ChallengeDetailsComponent, {disableClose: true, width: '600px', data: {challenge}});
  }

  openAddPositioning() {
    const dialogRef = this.dialog.open(AddEditPositioningComponent, {disableClose: true, width: '500px', data: {type: 'Add'}});
    dialogRef.afterClosed().subscribe((newPositioining) => {
      if (newPositioining) {
        this.getPositioning();
      }
    });
  }

  editPositioning(positioning: any) {
    const dialogRef = this.dialog.open(AddEditPositioningComponent, {
      disableClose: true,
      width: '500px',
      data: {
        type: 'Edit',
        positioning
      }
    });
    dialogRef.afterClosed().subscribe((editedPositioning) => {
      if (editedPositioning) {
        this.getPositioning();
      }
    });
  }

  deletePositioning(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'positioning',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('product/CompetitorPositioning/DeleteCompetitorPositioning/' + this.productId +'/' + id).then((data) => {
            if (data.statusCode === 200) {
              this.positioningList.forEach( (challenges, index) => {
                if (challenges.id === id) {
                  this.positioningList.splice(index, 1);
                  if (this.positioningList.length === 0 && this.pageNumber > 1) {
                    this.pageNumber = this.pageNumber - 1;
                    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
                      searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
                    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
                    '/competitor/' + this.competitorId + '/' + this.competitorName + '/positioning'], { queryParams: this.queryParams });
                  } else {
                    this.getPositioning();
                  }
                }
              });
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Positioning deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }

  moveToUsedOnMobile(id: any) {
    this.dataService.put('product/CompetitorPositioning/UpdateUsedOnMobile', {
      productId : parseInt(this.productId.toString(), 10),
      usedOnMobile : true,
      ProductCompetitorId: parseInt(this.competitorId.toString(), 10),
      CompetitorPositioningId: id,
    }).then((data) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile enabled successfully.',
            buttonText: 'Ok'
          }
        });
        this.getPositioning();
      }
    });
  }

  moveToNotUsedOnMobile(id: any) {
    this.dataService.put('product/CompetitorPositioning/UpdateUsedOnMobile', {
      productId : parseInt(this.productId.toString(), 10),
      usedOnMobile : false,
      ProductCompetitorId: parseInt(this.competitorId.toString(), 10),
      CompetitorPositioningId: id,
    }).then((data) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile disabled successfully',
            buttonText: 'Ok'
          }
        });
        this.getPositioning();
      }
    });
  }


  filterChange(value: any) {
    this.selected = value;
    if (value === 'manufacturer') {
      this.usedOnMobile = false;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/competitor/' + this.competitorId + '/' + this.competitorName + '/positioning'], { queryParams: this.queryParams });
    } else if (value === 'usedOnMobile') {
      this.usedOnMobile = true;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/competitor/' + this.competitorId + '/' + this.competitorName + '/positioning'], { queryParams: this.queryParams });
    }
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
      searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
      '/competitor/' + this.competitorId + '/' + this.competitorName + '/positioning'], { queryParams: this.queryParams });
  }

  handleSearchClick() {
    if (this.showSearch && this.positioningList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/competitor/' + this.competitorId + '/' + this.competitorName + '/positioning'], { queryParams: this.queryParams });
    }
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      usedOnMobile: this.usedOnMobile
    };
    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
      '/competitor/' + this.competitorId + '/' + this.competitorName + '/positioning'], { queryParams: this.queryParams });
  }

  getPositioning() {
    if (this.usedOnMobile ===  null) {
      this.dataService.get('product/CompetitorPositioning/RetrieveCompetitorPositioning/' +
      parseInt(this.productId.toString(), 10) + '/' + this.competitorId + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&AddedBy=2').then((data: any) => {
        if (data.statusCode === 200) {
          this.positioningList = [];
          const positioningData = data.data.records;
          this.totalSize = data.data.count;
          positioningData.forEach((challengeData: any) => {
            this.positioningList.push(challengeData);
          });
          if (positioningData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
              searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
              '/competitor/' + this.competitorId+ '/' + this.competitorName + '/positioning'], { queryParams: this.queryParams });
          }
        }
      });
    } else {
      let addedBy = this.usedOnMobile === "true" ? '4' : '2';
      if (this.usedOnMobile === true) {
        addedBy = '4';
      }
      this.dataService.get('product/CompetitorPositioning/RetrieveCompetitorPositioning/' +
      parseInt(this.productId.toString(), 10) + '/' + this.competitorId + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&usedOnMobile=' + this.usedOnMobile +
      '&AddedBy=' + addedBy).then((data: any) => {
        if (data.statusCode === 200) {
          this.positioningList = [];
          const positioningData = data.data.records;
          this.totalSize = data.data.count;
          positioningData.forEach((challengeData: any) => {
            this.positioningList.push(challengeData);
          });
          if (positioningData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
              searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
              '/competitor/' + this.competitorId + '/' + this.competitorName + '/positioning'], { queryParams: this.queryParams });
          }
        }
      });
    }
  }

}
